import { render, staticRenderFns } from "./QuizOver.vue?vue&type=template&id=288e4a3c&"
import script from "./QuizOver.vue?vue&type=script&lang=js&"
export * from "./QuizOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports